import React, { useState, useEffect } from "react";
import { getAuthHeader } from "../../api/authToken.js";
import "../../styles/App.css";
import { NO_GROUP_TEXT } from "../../components/GroupLabel.js";

const StudentTransfer = () => {
  const [students, setStudents] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState("");
  const [selectedRoom, setSelectedRoom] = useState("");
  const [currentRoom, setCurrentRoom] = useState(null);
  const [currentDormitory, setCurrentDormitory] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const API = process.env.REACT_APP_API_BASE;

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await fetch(`${API}/api/students`, {
          headers: { Authorization: getAuthHeader() },
        });
        const data = await response.json();
        setStudents(data);
        setFilteredStudents(data);
      } catch (error) {
        console.error("Помилка завантаження студентів:", error);
      }
    };

    fetchStudents();
  }, []);

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const response = await fetch(`${API}/api/available-rooms`, {
          headers: { Authorization: getAuthHeader() },
        });
        const data = await response.json();
        setRooms(data);
      } catch (error) {
        console.error("Помилка завантаження кімнат:", error);
      }
    };

    fetchRooms();
  }, []);

  useEffect(() => {
    const filtered = students.filter(
      (student) =>
        student.pib.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (student.group || "").toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredStudents(filtered);
  }, [searchQuery, students]);

  const handleStudentChange = async (e) => {
    const studentId = e.target.value;
    setSelectedStudent(studentId);
    setCurrentRoom(null);
    setCurrentDormitory(null);

    if (!studentId) return;

    try {
      const response = await fetch(`${API}/api/students/${studentId}`, {
        headers: { Authorization: getAuthHeader() },
      });
      const data = await response.json();

      if (response.ok && data.current_room) {
        setCurrentRoom(data.current_room); // Зберігаємо номер кімнати
        setCurrentDormitory(data.dormitory_name || "");
      } else {
        setError("Не вдалося отримати дані про поточну кімнату студента!");
        setCurrentRoom(null);
        setCurrentDormitory(null);
      }
    } catch (error) {
      console.error("Помилка отримання даних про кімнату студента:", error);
      setError("Помилка сервера.");
    }
  };

  const handleTransfer = async (e) => {
    e.preventDefault();

    if (!selectedStudent || !selectedRoom) {
      setError("Оберіть студента та нову кімнату.");
      setMessage("");
      return;
    }

    try {
      const response = await fetch(
        `${API}/api/relocate-student/${selectedStudent}`,
        {
          method: "POST",
          headers: {
            Authorization: getAuthHeader(),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ newRoomId: selectedRoom }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message);
        setError("");
        setSelectedStudent("");
        setSelectedRoom("");
        setCurrentRoom(null);
        setCurrentDormitory(null);

        const updatedRooms = rooms
          .map((room) =>
            room.id === selectedRoom
              ? { ...room, free_beds: room.free_beds - 1 }
              : room
          )
          .filter((room) => room.free_beds > 0);
        setRooms(updatedRooms);
      } else {
        setError(data.error || "Не вдалося переселити студента.");
        setMessage("");
      }
    } catch (error) {
      console.error("Помилка переселення:", error);
      setError("Помилка сервера. Спробуйте пізніше.");
      setMessage("");
    }
  };

  return (
    <div className="page-container">
      <h2 className="header-content-title">Переселення студента</h2>
      <form onSubmit={handleTransfer}>
        <div className="form-container">
          <label className="input-block text-header" htmlFor="student">
            Пошук студента:
            <input
              className="input-component"
              type="text"
              placeholder="Пошук за ПІБ або групою"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <select
              className="input-component"
              id="student"
              value={selectedStudent}
              onChange={handleStudentChange}
              required
            >
              <option value="">Оберіть студента</option>
              {filteredStudents.map((student) => (
                <option key={student.id} value={student.id}>
                  {student.pib} ({student.group || NO_GROUP_TEXT})
                </option>
              ))}
            </select>
          </label>

          <p className="input-block text-header">
            Поточна кімната:{" "}
            <strong>
              {currentDormitory} - {currentRoom}
            </strong>
          </p>
        </div>

        <div className="form-container">
          <label
            htmlFor="room"
            className="input-block text-header"
            style={{ width: "100%" }}
          >
            Оберіть нову кімнату:
            <select
              className="input-component"
              id="room"
              value={selectedRoom}
              onChange={(e) => setSelectedRoom(e.target.value)}
              required
            >
              <option value="">Оберіть кімнату</option>
              {[...rooms]
                .sort((a, b) =>
                  `${a.dormitory_name || ""} ${a.room_number}`.localeCompare(
                    `${b.dormitory_name || ""} ${b.room_number}`,
                    "uk"
                  )
                )
                .map((room) => (
                  <option key={room.id} value={room.id}>
                    {`${room.dormitory_name} - ${room.room_number} (вільних ліжок: ${room.free_beds})`}
                  </option>
                ))}
            </select>
          </label>
        </div>

        <button
          className="submit-button"
          type="submit"
          disabled={!selectedStudent || !selectedRoom}
        >
          Переселити студента
        </button>
      </form>

      {message && <p style={{ color: "green" }}>{message}</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default StudentTransfer;
